import { MutationTuple, QueryTuple, useLazyQuery, useMutation } from '@apollo/client';
import {
  ApproveCrewChangeRequestPayload,
  CancelCrewChangeRequestPayload,
  CrewChangeRequest,
  CrewChangeStatInput,
  CrewChangeStats,
  DeclineCrewChangeRequestPayload,
  Scalars,
} from '@bechtel/types';
import {
  APPROVE_CREW_CHANGE_REQUEST,
  CANCEL_CREW_CHANGE_REQUEST,
  DECLINE_CREW_CHANGE_REQUEST,
  GET_CREW_CHANGE_REQUEST_BY_IDs,
  GET_CREW_CHANGE_STATS,
} from '@bechtel/client-gql';

export function useApproveCrewChangeRequest(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ approveCrewChangeRequest: ApproveCrewChangeRequestPayload }, { crewChangeRequestId: Scalars['ID'] }> {
  const response = useMutation<
    { approveCrewChangeRequest: ApproveCrewChangeRequestPayload },
    { crewChangeRequestId: Scalars['ID'] }
  >(APPROVE_CREW_CHANGE_REQUEST, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries: ['crewChangeStats'],
  });
  return response;
}

export function useDeclineCrewChangeRequest(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ declineCrewChangeRequest: DeclineCrewChangeRequestPayload }, { crewChangeRequestId: Scalars['ID'] }> {
  const response = useMutation<
    { declineCrewChangeRequest: DeclineCrewChangeRequestPayload },
    { crewChangeRequestId: Scalars['ID'] }
  >(DECLINE_CREW_CHANGE_REQUEST, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries: ['crewChangeStats'],
  });
  return response;
}

export function useCrewChangeRequestsByIds(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewChangeRequestsByIds: CrewChangeRequest[] }, Record<string, any>> {
  const response = useLazyQuery<{
    crewChangeRequestsByIds: CrewChangeRequest[];
  }>(
    GET_CREW_CHANGE_REQUEST_BY_IDs,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}

export function useCancelCrewChangeRequest(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ cancelCrewChangeRequest: CancelCrewChangeRequestPayload }, { crewChangeRequestId: Scalars['ID'] }> {
  const response = useMutation<
    { cancelCrewChangeRequest: CancelCrewChangeRequestPayload },
    { crewChangeRequestId: Scalars['ID'] }
  >(CANCEL_CREW_CHANGE_REQUEST, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
    refetchQueries: ['crewChangeStats'],
  });
  return response;
}

export function useCrewChangeStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ crewChangeStats: CrewChangeStats }, { input: CrewChangeStatInput }> {
  const response = useLazyQuery<{ crewChangeStats: CrewChangeStats }, { input: CrewChangeStatInput }>(
    GET_CREW_CHANGE_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          nextFetchPolicy: 'cache-first',
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
          nextFetchPolicy: 'cache-first',
        }
  );
  return response;
}
